import PhoneShowcase from "./PhoneShowcase";

/**
 * AuthShowcase — cinematic dark stage rendered on the left half on large
 * screens (lg+). Hidden on mobile/tablet. A premium iPhone mockup runs a
 * live WhatsApp conversation — the product demoing itself while the user
 * signs in. Shared by /login, /register, /forgot-password, /reset-password.
 */
export default function AuthShowcase() {
  return (
    <aside
      data-testid="auth-showcase"
      className="hidden lg:flex relative basis-1/2 grow-0 shrink-0 min-h-screen flex-col text-white overflow-hidden"
      style={{ backgroundColor: "#04060B" }}
    >
      {/* Glow behind the phone — the device is the light source of the scene */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(560px 640px at 50% 58%, rgba(37,211,102,0.10), transparent 62%), radial-gradient(760px 560px at 50% 46%, rgba(96,140,255,0.09), transparent 65%), radial-gradient(900px 500px at 50% 110%, rgba(255,255,255,0.04), transparent 70%)",
        }}
      />
      {/* Subtle dot grid */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #ffffff 1px, transparent 0)",
          backgroundSize: "34px 34px",
        }}
      />
      {/* Bottom fade */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 bottom-0 h-36 bg-gradient-to-t from-black/70 to-transparent"
      />

      {/* TOP — brand + live badge */}
      <div className="relative z-10 flex items-center justify-between px-10 xl:px-14 pt-8">
        <img
          src="/logo-white.png"
          alt="AgentUS"
          className="h-[18px] w-auto opacity-95 select-none"
          draggable="false"
        />
        <span className="inline-flex items-center gap-2 rounded-full border border-white/[0.09] bg-white/[0.03] px-3 py-1.5">
          <span className="relative flex w-1.5 h-1.5">
            <span className="absolute inline-flex w-full h-full rounded-full bg-emerald-400 opacity-60 animate-ping" />
            <span className="relative inline-flex w-1.5 h-1.5 rounded-full bg-emerald-400" />
          </span>
          <span className="text-[9.5px] uppercase tracking-[0.22em] text-white/55 font-medium select-none">
            Ao vivo
          </span>
        </span>
      </div>

      {/* CENTER — headline + live phone */}
      <div className="relative z-10 flex-1 min-h-0 flex flex-col items-center justify-center px-10 py-6 gap-6">
        <div className="text-center">
          <div className="text-[9.5px] uppercase tracking-[0.32em] text-white/35 font-medium mb-3 select-none">
            A nova camada operacional
          </div>
          <h2
            className="font-heading text-[26px] xl:text-[30px] font-semibold leading-[1.12] tracking-[-0.025em]"
            style={{ textWrap: "balance" }}
          >
            Isso não é um chatbot.
            <br />
            <span className="text-white/50">É a sua operação, ao vivo.</span>
          </h2>
        </div>

        <PhoneShowcase />
      </div>

      {/* BOTTOM — pillars */}
      <div className="relative z-10 px-10 xl:px-14 pb-7">
        <div className="flex items-center justify-center gap-8 mb-4">
          <Pillar label="WhatsApp 24/7" />
          <Pillar label="Decisão automática" />
          <Pillar label="Auditoria total" />
        </div>
        <p className="text-[9.5px] tracking-[0.18em] uppercase text-white/22 text-center">
          Multi-tenant · Audit-first · API-ready
        </p>
      </div>
    </aside>
  );
}

function Pillar({ label }) {
  return (
    <div className="flex items-center gap-2 text-[11px] text-white/50 tracking-tight">
      <span className="w-4 h-px bg-white/25" />
      {label}
    </div>
  );
}
